import type { UtmParameters } from '@shared/core/router.helper/RoutesContext';

/** Shared UTM parameters for guest guide travel CTAs. */
export const GUEST_GUIDE_UTM: UtmParameters = {
  utm_medium: 'web',
  utm_campaign: 'guest_guide',
  utm_source: 'guest_guide_guest_site',
};

/** The booking CTA card reports its own source but shares the guide's medium and campaign. */
export const GUEST_GUIDE_BOOKING_CTA_UTM: UtmParameters = {
  ...GUEST_GUIDE_UTM,
  utm_source: 'guest_guide_booking_cta',
};
